// Shared across the header and intro
export default {
  url: {
    id: 'rm_back_market_url',
    defaultMessage: 'https://www.backmarket.com/en-us',
  },
  label: {
    id: 'rm_back_market_label',
    defaultMessage: 'Back Market',
  },
} as const
